import { createDinero } from '@mr-yum/frontend-core/dist/services/createDinero'
import { IconCard } from 'components/Common/IconCard'
import { useLogger } from 'hooks/useLogger'
import { OrderConfirmationPartsFragment } from 'lib/gql'
import React, { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  href: string
  order: OrderConfirmationPartsFragment
  currency: string
}

export const TipJarBanner = ({ href, order, currency }: Props) => {
  const loggerProps = useMemo(
    () => ({ defaultProperties: { url: href, orderId: order.id } }),
    [href, order],
  )
  const { logEvent } = useLogger(loggerProps)

  const billDollarAmount = createDinero(order.totalInCents, currency).toUnit()
  const orderQueryParams = `&t=${order.id}&b=${billDollarAmount}`

  const tipjarLogo = (
    <img
      className="h-full w-full bg-[#01FFCC] object-contain p-1"
      src="/static/tipjar-logo.png"
      alt="TiPJAR logo"
    />
  )
  const tipjarTitle = (
    <FormattedMessage defaultMessage="Leave a tip with TiPJAR" id="qClrZg" />
  )
  const tipjarDescription = (
    <FormattedMessage
      defaultMessage="100% of your money goes directly to our team."
      id="KnDGyg"
    />
  )

  return (
    <IconCard
      heading={tipjarTitle}
      description={tipjarDescription}
      href={`${href}?p=mryum` + orderQueryParams}
      icon={tipjarLogo}
      onClick={() => logEvent(`Clicked TipJar banner`)}
      target="_blank"
      rel="external noreferrer"
    />
  )
}
